package com.bikompanion.ui.composables

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.BugReport
import androidx.compose.material.icons.filled.LocationSearching
import androidx.compose.material.icons.filled.MyLocation
import androidx.compose.material.icons.filled.Navigation
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material3.ExtendedFloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.SmallFloatingActionButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.bikompanion.ui.models.LocateMode
import com.bikompanion.ui.preview.PreviewSurface
import com.bikompanion.ui.strings.LocalStrings

/**
 * The settings and locate-me FABs in the bottom-end corner.
 */
@Composable
internal fun HomeFabColumn(
    onSettingsClick: () -> Unit,
    locateMode: LocateMode,
    onLocateMeClick: () -> Unit,
    modifier: Modifier = Modifier,
    showDebugNotificationButton: Boolean = false,
    onDebugNotificationClick: () -> Unit = {},
) {
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.End,
        verticalArrangement = Arrangement.spacedBy(4.dp),
    ) {
        if (showDebugNotificationButton) {
            ExtendedFloatingActionButton(
                onClick = onDebugNotificationClick,
                icon = { Icon(Icons.Default.BugReport, contentDescription = null) },
                text = { Text("Test notification") },
            )
        }
        SmallFloatingActionButton(onClick = onSettingsClick) {
            Icon(imageVector = Icons.Default.Settings, contentDescription = LocalStrings.current.settingsTitle)
        }
        SmallFloatingActionButton(onClick = onLocateMeClick) {
            val (icon, description) = when (locateMode) {
                LocateMode.Off -> Icons.Default.LocationSearching to LocalStrings.current.locateShow
                LocateMode.Centered -> Icons.Default.MyLocation to LocalStrings.current.locateFollowHeading
                LocateMode.FollowingHeading -> Icons.Default.Navigation to LocalStrings.current.locateStopFollowing
            }
            Icon(imageVector = icon, contentDescription = description)
        }
    }
}

@Preview
@Composable
private fun HomeFabColumnPreview() {
    PreviewSurface {
        Row(
            modifier = Modifier.padding(16.dp),
            horizontalArrangement = Arrangement.spacedBy(16.dp),
        ) {
            LocateMode.entries.forEach { mode ->
                HomeFabColumn(onSettingsClick = {}, locateMode = mode, onLocateMeClick = {})
            }
        }
    }
}

@Preview
@Composable
private fun HomeFabColumnDebugPreview() {
    PreviewSurface {
        HomeFabColumn(
            onSettingsClick = {},
            locateMode = LocateMode.Off,
            onLocateMeClick = {},
            modifier = Modifier.padding(16.dp),
            showDebugNotificationButton = true,
        )
    }
}
